/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from '../convo/defs.defs.js'

const $nsid = 'chat.bsky.moderation.getMessageContext'

export { $nsid }

const main = l.query(
  $nsid,
  l.params({
    convoId: l.optional(l.string()),
    messageId: l.string(),
    before: l.optional(l.withDefault(l.integer(), 5)),
    after: l.optional(l.withDefault(l.integer(), 5)),
  }),
  l.jsonPayload({
    messages: l.array(
      l.typedUnion(
        [
          l.typedRef<ConvoDefs.MessageView>(
            (() => ConvoDefs.messageView) as any,
          ),
          l.typedRef<ConvoDefs.DeletedMessageView>(
            (() => ConvoDefs.deletedMessageView) as any,
          ),
        ],
        false,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
